module.exports = __webpack_public_path__ + "media/images/headset-solid-aa28ad20d14540c47f8d2379f8e558a3.svg";